import { ListingService } from "@/services/listing/listingService";
import type { ListingType } from "@/types/listing";

export function parseListingTitleFromEventDetails(
  details?: string,
): string | null {
  const match = details?.match(/Titel:\s*([^.]+)/i);
  return match?.[1]?.trim() || null;
}

export async function resolveListingIdFromEvent(options: {
  regNumber?: string;
  title?: string | null;
  listingType?: ListingType;
}): Promise<string | null> {
  const { regNumber, title, listingType = "auction" } = options;
  if (!regNumber && !title) return null;

  const response = await ListingService.getAllListings({
    regNumber,
    search: title || undefined,
    listingType,
    limit: 50,
  });

  const listings = response.listings ?? response.data ?? [];
  if (!listings.length) return null;

  if (title) {
    const normalized = title.trim().toLowerCase();
    const exact = listings.find(
      (l) => l.title?.trim().toLowerCase() === normalized,
    );
    if (exact) return exact.id;
  }

  const sorted = [...listings].sort(
    (a, b) =>
      new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );
  return sorted[0]?.id ?? null;
}
